export enum AuroraCirculationPumpMode {
  AUTO = 0,
  MAX = 4,
  MIN = 6
}

export default AuroraCirculationPumpMode
